import React, { useState, useEffect,useRef } from "react";
import { getYoutubePosterImage, getRouting } from "../../../../../../../utils/common";
import "./style.scss";
import { Helmet } from "react-helmet";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { mdVideosDetails } from "../../../actions";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";

const VideosDetail = (props) => {
  const {
    mdVideosDetails,
    mdvideoDetailData,
    location: { pathname },
  } = props;

  const currentDetail = pathname.split("/")[4];
  const [videoData, setVideoData] = useState();
  const [metaData, setmetaData] = useState();

  useEffect(()=>{
    mdVideosDetails({},currentDetail)
  },[currentDetail])
  useEffect(()=>{
    if(mdvideoDetailData){
      setVideoData(mdvideoDetailData);
    }
    if(mdvideoDetailData && mdvideoDetailData.meta){
      setmetaData(mdvideoDetailData.meta);
    }
  },[mdvideoDetailData])
  console.log("videoData",videoData);

  const handleChangeVideo = async (e, item) => {
    mdVideosDetails({},item.suggestedUrl);
  };

  useEffect(() => {
    if (videoData) {
      window.scrollTo(0, 0);
    }
  }, [videoData]);

  // dropdown start

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [isOpen]);

  //dropdown end

  return (
    <div className="wrapper">
     {metaData && metaData !== null && <Helmet>
        <title>{metaData.title ? metaData.title : ""}</title>
        <meta name="description" content={metaData.description ? metaData.description : ""} />
        <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
        <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
        <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
        <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
        <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
      </Helmet>}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <div className="me-auto" ref={dropdownRef}>
              <div
                // onClick={toggleDropDown}
              >
                <h1>
                  <span>Videos</span>
                  {/* <img
                    className="ms-2"
                    src="/images/New/redDownArrow.svg"
                    alt="arrow"
                  /> */}
                </h1>
              </div>
              {/* {isOpen && (
                <ul className="dropdown-body" aria-labelledby="dropdownMenuLink">
                  <li>
                    <a
                      className="dropdown-item fw-bold"
                      href="/knowledge-stack/md-ceo-desk/md-speaks/articles"
                    >
                      Articles written by MD
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item fw-bold"
                      href="/knowledge-stack/md-ceo-desk/md-speaks/articles"
                    >
                      Articles written by MD
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item fw-bold"
                      href="/knowledge-stack/md-ceo-desk/media/interview"
                    >
                      Interview Articles
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item fw-bold"
                      href="/knowledge-stack/md-ceo-desk/media/video"
                    >
                      Video Interaction
                    </a>
                  </li>
                </ul>
              )} */}
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/`)}>Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/knowledge-stack`)}> Knowledge Stack </Link>
                </li>
                <li className="breadcrumb-item" aria-current="page">
                  <Link to={getRouting(`/knowledge-stack/md-ceo-desk/videos`)}>Message from MD & CEO's Desk</Link>
                </li>
                <li className="breadcrumb-item active breadcolor" aria-current="page">
                  <Link to={getRouting(`/knowledge-stack/md-ceo-desk/videos`)}>Videos</Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="row mb-5 mt-5">
            <div className="col-md-7 videosec mb-4">
              <ReactPlayer
                url={
                  videoData && videoData.youtubeId
                    ? `https://www.youtube.com/watch?v=${videoData.youtubeId}`
                    : ""
                }
                controls="true"
                className="videoplayer"
                muted={true}
                playing={true}
              />
              <div className="defaultVideoDetails">
                <h2>
                  {videoData && videoData.title
                    ? videoData.title
                    : ""}
                </h2>
                {videoData && videoData.youtube_desc ? 
                  <div
                  dangerouslySetInnerHTML={{
                    __html: videoData.youtube_desc,
                  }}
                  /> : ''
                  }
              </div>
            </div>
            <div className="col-md-5 videosecright mb-4">
              {videoData &&
              videoData.otherVideos &&
              videoData.otherVideos.latestVideos &&
              videoData.otherVideos.latestVideos.length > 0 &&
              videoData.otherVideos.latestVideos.map((item) => {
                const posterImage = getYoutubePosterImage(item.youtubeId);
                return (
                  <Link
                    to={getRouting(
                      `/knowledge-stack/md-ceo-desk/videos/${item.suggestedUrl}`
                    )}
                  >
                    <div className="row mb-3">
                      <div className="col-6">
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => handleChangeVideo(e, item)}
                        >
                          <div className="mainvideo">
                            {!posterImage ? (
                              <img
                                src="/images/New/learnNew/articlesimg.svg"
                                className="w-100 imgh webinarvideo"
                              />
                            ) : (
                              <img
                                src={posterImage}
                                className="w-100 imgh webinarvideo"
                              />
                            )}
                            <img
                              src="/images/New/learnNew/you-tube-play-icon.png"
                              className="playicon"
                              alt="youtube-play-button-icon"
                            />
                            {item.duration ? (
                              <div className="readcls">
                                {item.duration}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </a>
                      </div>

                      <div className="col-6">
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => handleChangeVideo(e, item)}
                          className="leftVideoTitle"
                        >
                          <h3>
                            {item.title
                              ? item.title
                              : ""}
                          </h3>
                          <p className="">
                            {item.youtube_desc ? 
                            <div
                            dangerouslySetInnerHTML={{
                              __html: item.youtube_desc,
                            }}
                            /> : ''
                            }
                          </p>
                        </a>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  mdvideoDetailData: state.KnowledgeStack.mdspeakVideoDetail,
});

const mapDispatchToProps = (dispatch) => ({
  mdVideosDetails: bindActionCreators(mdVideosDetails, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideosDetail);

